import { useState } from 'react';

export default function TeamCollaborationSection() {
  const [activeItem, setActiveItem] = useState('tasks');

  const navItems = [
    { id: 'tasks', label: '任务管理', icon: 'ri-task-line' },
    { id: 'workflow', label: '工作流', icon: 'ri-node-tree' },
    { id: 'communication', label: '团队沟通', icon: 'ri-team-line' }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-12 lg:px-16 xl:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* 左侧文字介绍 */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                团队协同
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                高效的团队协作工具，提升工作效率，确保项目顺利推进
              </p>
              
              {/* 导航菜单 */}
              <div className="mb-8">
                {navItems.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => setActiveItem(item.id)}
                    className={`relative flex items-center px-4 py-3 mb-2 rounded-lg cursor-pointer transition-colors ${
                      activeItem === item.id
                        ? 'bg-blue-50 text-blue-700'
                        : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    {activeItem === item.id && (
                      <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-600 rounded-r"></div>
                    )}
                    <i className={`${item.icon} mr-3 text-lg`}></i>
                    <span className="font-medium">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* 右侧图片 */}
            <div className="flex items-center justify-center">
              <img 
                src="/5.png" 
                alt="团队协同" 
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

